import axios from 'axios';

// Dengan menggunakan fitur proxy di package.json, kita tidak perlu lagi menyetel baseURL secara eksplisit.
// React development server akan secara otomatis meneruskan permintaan ke "http://localhost:3001".
axios.defaults.baseURL = process.env.REACT_APP_API_URL; // Setel base URL dari variabel lingkungan

// Interceptor untuk menambahkan log pada setiap request
axios.interceptors.request.use(
  (config) => {
    // Menambahkan timestamp untuk mempermudah debugging
    const timestamp = new Date().toLocaleTimeString();
    console.log(`[${timestamp}] Mengirim ${config.method.toUpperCase()} request ke: ${config.url}`);

    // Secara otomatis menambahkan token otorisasi jika ada
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error('[Request Error]', error);
    return Promise.reject(error);
  }
);

// Interceptor untuk menambahkan log pada setiap response
axios.interceptors.response.use(
  (response) => {
    const timestamp = new Date().toLocaleTimeString();
    console.log(
      `[${timestamp}] Menerima Response dari ${response.config.url} (Status: ${response.status})`,
      response.data
    );
    return response;
  },
  (error) => {
    const timestamp = new Date().toLocaleTimeString();
    if (error.response) {
      // Error yang berasal dari response server (status 4xx atau 5xx)
      console.error(`[${timestamp}] Error Response dari ${error.config.url} (Status: ${error.response.status}):`,
        {
          data: error.response.data,
          headers: error.response.headers,
        }
      );
    } else if (error.request) {
      // Error karena request dibuat tapi tidak ada response (masalah jaringan, dll)
      console.error(`[${timestamp}] Network Error: Tidak ada response untuk request ke ${error.config.url}`);
    } else {
      // Error lain saat setup request
      console.error(`[${timestamp}] General Error:`, error.message);
    }
    return Promise.reject(error);
  }
);

export default axios;
